import React from 'react';


import { useFx } from '../../../hooks/fx';
import { Money } from '../../../components';

const Profit = ({
  type,
  buy,
  buyCurrency,
  sell,
  sellCurrency,
  market,
  trade,
  avgCurrency,
}) => {
  // rate is null when no rate is known (request failed and nothing was
  // cached): show "Rate unavailable", never a 1:1 figure. See hooks/fx.js.
  const { rate, isLoading, unavailable } = useFx(...(
    type === 'order' ? [buyCurrency || "gbp", sellCurrency || "gbp"] : [avgCurrency || "gbp", buyCurrency || "gbp"]
  ));

  if (isLoading ||
    (type === 'order' && (!sell || !buy)) ||
    (type === 'sell' && !buy && !(market || trade))
  ) {
    return <span>💰</span>;
  }

  if (rate == null) {
    return unavailable ? (
      <span className="text-muted" title="Exchange rate unavailable">Rate unavailable</span>
    ) : (
      <span>💰</span>
    );
  }

  if (type === 'order') {
    const profit = Math.round(parseFloat(sell) - parseFloat(buy * rate));

    return (
      <Money amount={profit} currency={sellCurrency?.toLowerCase()} className="money" />
    );
  }

  const minProfit = trade &&
    Math.round(parseFloat(trade * rate) - parseFloat(buy));
  const maxProfit = market &&
    Math.round(parseFloat(market * rate) - parseFloat(buy));

  return (
    <span className="profit-range">
      {trade && buy ? (
        <Money amount={minProfit} currency={buyCurrency?.toLowerCase()} className="money" />
      ) : (
       <span>💰</span>
      )}

      &nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;

      {market && buy ? (
        <Money amount={maxProfit} currency={buyCurrency?.toLowerCase()} className="money" />
      ) : (
        <span>💰</span>
      )}
    </span>
  )
}

export default Profit;
